<template>
  <action-dispatcher
    action="courses/getDetails"
    :parameters="$route.params.id"
    ref="coursesDispatcher"
    class="view-course"
  >
    <header :style="headerStyle">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-4">
            <h1>{{ course.title }}</h1>
            <span class="badge">{{ category }}</span>
            <p class="mt-3" v-html="course.description" />

            <!-- <div class="row mx-n1 align-items-center mb-5">
              <div class="col-6 px-1">
                <div class="progress rounded-pill">
                  <div
                    class="progress-bar rounded-pill btn-success"
                    :style="`width: ${progressPercentage}%`"
                  ></div>
                </div> 
              </div>
              <div class="col-6 px-1 font-weight-bold">
                {{ progressPercentage }}% concluído
              </div>
            </div> -->

            <div v-if="currentLesson" class="py-2">
              <router-link
                class="btn btn-primary px-5 d-inline-flex align-items-center btn-lg font-weight-bold"
                :to="{ name: 'lesson', params: { lesson: currentLesson.id } }"
              >
                <span v-if="currentLesson.number === 1">Iniciar Jornada</span>
                <span v-else>Continuar trilha</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </header>

    <div class="container-fluid pt-5">
      <lessons-list
        class="order-lg-2"
        :course="course"
        :course-id="$route.params.id"
      />
    </div>
  </action-dispatcher>
</template>

<script>
import LessonsList from "../components/course/LessonsList";
import get from "lodash/get";
import { mapState } from "vuex";

export default {
  components: { LessonsList },
  computed: {
    ...mapState("courses", ["course"]),
    headerStyle() {
      const bg = url =>
        `background-image: linear-gradient(80deg, #001535 -5%, rgba(0, 0, 0, 0.1) 50%), url("${url}");`;
      return bg(this.course.cover || get(this.currentLesson, "picture"));
    },
    currentLesson() {
      return (
        this.course &&
        this.course.lessons &&
        this.course.lessons.find(
          lesson => !lesson.progress || !lesson.progress.finished_at
        )
      );
    },
    numLessons() {
      return get(this.course, "lessons.length", 0);
    },
    category() {
      return get(this.course, "lessons[0].category.name", "");
    },
    progressPercentage() {
      return Math.round(
        get(
          this.$user.user.progress_list.find(
            p => p.course_id === parseInt(this.$route.params.id)
          ),
          "progress"
        )
      );
    }
  },
  mounted() {
    this.$store.dispatch("user/get");
  }
};
</script>

<style lang="scss" scoped>
.view-course {
  header {
    padding: 120px 0 100px;
    background-size: cover;
    background-position-x: center;
    background-position-y: center;

    @media screen and (min-width: 992px) {
      height: 0;
      padding: 0 0 45%;
      width: 100%;
      position: relative;

      .container-fluid {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    hr {
      width: 100px;
      border-width: 3px;
      border-color: white;
      margin-left: 0;
    }

    .badge {
      font-size: 14px;
      font-weight: bold;
      color: white;
    }

    p {
      ::v-deep * {
        color: white !important;
      }
    }

    a {
      line-height: 34px;
    }
  }
}
</style>
